import { ApolloClient, InMemoryCache, ApolloLink } from "apollo-boost";
import { createUploadLink } from "apollo-upload-client";

import Vue from "vue";
import VueApollo from "vue-apollo";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { checkPermissions } from "./utils";
import axios from "axios";
import * as R from "ramda";
import VueTheMask from "vue-the-mask";
import voca from "voca";
import vueDebounce from "vue-debounce";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/es";
import "@/assets/styles/elemets-variables.scss";
import "@/assets/styles/font-awesome.less";
import "./assets/styles/main.css";

import vOutsideEvents from "vue-outside-events";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";


function roundNumber(num, scale) {
  if (!("" + num).includes("e")) {
    return +(Math.round(num + "e+" + scale) + "e-" + scale);
  } else {
    var arr = ("" + num).split("e");
    var sig = ""
    if (+arr[1] + scale > 0) {
      sig = "+";
    }
    return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
  }
}

function roundStringNumberWithoutTrailingZeroes(num, dp) {
  if (arguments.length != 2) throw new Error("2 arguments required");
  num = String(num);

  if (num.indexOf('e+') != -1) {
    throw new Error("num too large");
  }

  if (num.indexOf('.') == -1) {
    return num;
  }

  var parts = num.split('.'),
    beforePoint = parts[0],
    afterPoint = parts[1],
    shouldRoundUp = afterPoint[dp] >= 5,
    finalNumber;

  afterPoint = afterPoint.slice(0, dp);
  if (!shouldRoundUp) {
    finalNumber = beforePoint + '.' + afterPoint;
  } else if (/^9+$/.test(afterPoint)) {
    finalNumber = Number(beforePoint) + 1;
  } else {
    var i = dp - 1;
    while (true) {
      if (afterPoint[i] == '9') {
        afterPoint = afterPoint.substr(0, i) +
          '0' +
          afterPoint.substr(i + 1);
        i--;
      } else {
        afterPoint = afterPoint.substr(0, i) +
          (Number(afterPoint[i]) + 1) +
          afterPoint.substr(i + 1);
        break;
      }
    }
    finalNumber = beforePoint + '.' + afterPoint;
  }
  if (typeof finalNumber == 'number') {
    finalNumber = finalNumber.toString()
  }
  return finalNumber.replace(/0+$/, '')
}


Number.prototype.roundDecimal = function () {
  return Math.round((this + Number.EPSILON) * 100) / 100
}

Vue.use(ElementUI, { locale });
Vue.use(vOutsideEvents);
Vue.use(PerfectScrollbar);
Vue.use(VueTheMask);
Vue.use(VueApollo);
Vue.use(vueDebounce);
Vue.config.productionTip = false;

Vue.filter("formatDate", function (value, fromFormat = null) {
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  if (!R.isNil(value)) {
    switch (fromFormat) {
      case "YYYY-MM-DD":
        return new Intl.DateTimeFormat("es-ES", options).format(
          new Date(value).setDate(new Date(value).getDate() + 1)
        );
      default:
        const date = value
          .split("/")
          .reverse()
          .join("-");
        return new Intl.DateTimeFormat("es-ES", options).format(
          new Date(value).setDate(new Date(value).getDate() + 1)
        );
    }
  } else {
    return "";
  }
});

Vue.filter("formatMoney", function (value) {
  if (typeof value == "string") {
    return value;
  } else {
    switch (value) {
      case null:
        return "";
      case "N/A":
        return "N/A";
      default:
        return new Intl.NumberFormat("es-GT", {
          style: "currency",
          currency: "GTQ",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
    }
  }
});

Vue.filter("formatNumber", function (value) {
  if (typeof value == "string") {
    return value;
  } else {
    switch (value) {
      case null:
        return "";
      case "N/A":
        return "N/A";
      default:
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximunFractionDigits: 2,
        }).format(value);
    }
  }
});

Vue.filter("capitalizeString", function (value) {
  return voca.capitalize(value, true);
});

//const API_PATH = "http://192.168.102.141:4001"
//const API_PATH = "https://rrhh-api.yes.com.sv"
const API_PATH = "https://rrhh-api-gt.yes.com.sv"

//const API_PATH = "http://rrhh-api-gt-app-1:4000"

//   process.env.NODE_ENV === "development"
//     ? "http://localhost:4000"
//     // ? "http://services.lws.local:4005"
//     : "http://192.168.102.141:4001/";
// // : "http://services.lws.local:4005";

axios.defaults.baseURL = API_PATH
//process.env.NODE_ENV === "development" ? "http://localhost:4000" : API_PATH;
axios.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});
axios.interceptors.response.use(
  (response) => {
    if (
      !R.isNil(response.data.errors) &&
      response.data.errors[0].message === "not valid"
    ) {
      ElementUI.Message.error({
        title: "Error",
        message: "Sesión no válida, inicia sesión nuevamente",
      });
      store.commit("processLogout");
      return false;
    }
    return response;
  },
  (err) => { }
);

const main = async () => {
  if (!R.isNil(store.getters.token)) {
    const res = await axios.post("/", {
      query: ` mutation {  
        validateSession { 
          token 
          user { 
            id
            email 
            changePassword 
            isActive 
            names
            lastnames
            avatarURL 
            super
            permissions
          }
        } 
      }`,
    });
    const { data, errors } = res.data;
    if (!R.isNil(data)) {
      store.commit("createSession", data.validateSession);
    }
  }

  router.beforeEach((to, from, next) => {
    if (to.path) {
      NProgress.start();
    }
    if (to.path === "/") {
      next();
    } else {
      let cont = store.getters.isLogged;
      if (cont) {
        const { path, action } = to.meta
        if (checkPermissions(path, action)) {
          next();
        } else {
          next("/");
          NProgress.done();
        }
      } else {
        next("/");
      }
    }
  });

  router.afterEach((to, from) => {
    NProgress.done();
  });

  router.onError((error) => {
    NProgress.done();
    let message = error.message;
    if (message === "not valid") {
      message = "Sesión no válida, inicia sesión nuevamente";
      store.commit("processLogout");
    }
    ElementUI.Message.error({
      title: "Error",
      message,
    });
    return false;
  });

  const httpLink = createUploadLink({ uri: API_PATH });
  const authLink = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: { authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return forward(operation);
  });

  const defaultClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });

  const apolloProvider = new VueApollo({ defaultClient });
  new Vue({
    apolloProvider,
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
};
main();
